import { createFileRoute } from "@tanstack/react-router"
import { ShopifyIntegration } from "modules/settings/components/integrations/shopify"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/shopify")({
  component: ShopifyIntegration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.shopify.title"),
    })
  },
})
